interface IIASDataSharing {
  key: string;
  text: string;
}

export function getThirdPartyDataSharingItems(): IIASDataSharing[] {
  return [
    {
      key: 'app_id',
      text: 'App ID',
    },
    {
      key: 'channel_name',
      text: 'Channel Name',
    },
    {
      key: 'content_genre',
      text: 'Content Genre',
    },
    {
      key: 'content_category',
      text: 'Content Category',
    },
    {
      key: 'content_title',
      text: 'Content Title',
    },
    {
      key: 'content_rating',
      text: 'Content Rating',
    },
    {
      key: 'content_series',
      text: 'Content Series',
    },
    {
      key: 'content_network',
      text: 'Content Network',
    },
    {
      key: 'content_distrib_name',
      text: 'Content Distributer Name',
    },
    {
      key: 'content_prodqual',
      text: 'Content Prodqual',
    },
    {
      key: 'content_keywords',
      text: 'Content Keywords',
    },
    {
      key: 'content_language',
      text: 'Content Language',
    },
  ];
}
